import { createActionsColumn } from '@app/modules/audit/components/create-actions-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { NoMatchesReport, toDateStr } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDateTime } from '../../../../../../../../components/date/LDateTime';
import { RowActions } from '../../../../../../../../components/table/RowActions';
import { ReportResultProps } from '../../../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../../../core/stations/hooks/useActiveStation';
import { AuditMediaPlayerAction } from '../../../../components/AuditMediaPlayerAction';
import { MatchLink } from './MatchLink';
import { AudiosWithoutMatchesReport } from './types';

export function NoMatchesReportResult(p: ReportResultProps<AudiosWithoutMatchesReport>) {
  const { $t } = useIntl();
  const station = useActiveStation();

  return (
    <MrtTable
      data={p.result.items}
      muiTableBodyRowProps={({ row }) => ({
        className: row.original.sameMd5MatchedAudio ? 'table-warning' : '',
      })}
      columns={[
        createCustomIdColumn<NoMatchesReport['items'][number]>($t, {
          accessor: (row) => row.audio.customId,
          size: 140,
        }),
        {
          id: 'createdAt',
          header: $t({
            id: 'common.createdAt',
            defaultMessage: 'Creado',
          }),
          accessorKey: 'audio.createdAt',
          size: 120,
          Cell: ({ row }) => <LDateTime value={row.original.audio.createdAt} />,
        },
        {
          id: 'notes',
          header: $t({
            id: 'common.notes',
            defaultMessage: 'Notas',
          }),
          Cell: ({ row }) => {
            const item = row.original;

            return (
              item.sameMd5MatchedAudio && (
                <MatchLink
                  audio={item.sameMd5MatchedAudio}
                  url={`/audit/s/${station.slug}/reports/no-matches?audio_id=${
                    item.sameMd5MatchedAudio.customId
                  }&from=${toDateStr(p.values.matchFrom)}&to=${toDateStr(p.values.matchTo)}`}
                />
              )
            );
          },
        },
        createActionsColumn<NoMatchesReport['items'][number]>($t, {
          size: 80,
          Cell: ({ row }) => (
            <RowActions>
              {row.original.audio && (
                <AuditMediaPlayerAction
                  audio={{
                    ...row.original.audio,
                    stationId: station.id,
                  }}
                />
              )}
            </RowActions>
          ),
        }),
      ]}
    />
  );
}
